module.exports = __webpack_public_path__ + "img/BANNER_RITUAL.e0f667cf.png";